import CustomScroll from "@src/component/customScroll"
import { memo, useEffect, useState } from "react";
import "./index.scss"
import { TextArea, Toast } from "antd-mobile";
import MiModal from "@src/component/miModal";
import { getQueryParams } from "@src/util";
import { miLoadList, loadReason } from "@src/service/ownService";

const ApplyDetail = () => {
  const [refuse, setRefuse] = useState<string>('');
  const [visible, setVisible] = useState<boolean>(false);
  const [reVisible, setReVisible] = useState<boolean>(false);
  const [data, setData] = useState<any>("");
  const [financePlanStatus, setFinancePlanStatus] = useState<any>();
  const [periodsVal,setPeriodsVal] = useState<number>(0) //盗抢分期年限
  const search = getQueryParams();
  useEffect(() => {
    document.title = "我的金融方案"
  }, [])

  useEffect(() => {
    getData(search?.loanid);
    setFinancePlanStatus(search.status)
  }, [])

  // 获取数据
  const getData = async (id: string) => {
    try {
      const res = await miLoadList(id);
      console.log(res)
      getSsqyPeriods(res.data)
      setData(res.data);
    } catch (err: any) {
      Toast.show(err?.errmsg || "获取金融方案失败");
    }
  }

  // 操作
  const subMitData = (obj:any) =>{
    Toast.show({
      icon: 'loading',
      content: '加载中…',
      duration: 0,
      maskClickable: false
    })
    obj.type = search.type
    obj.loaningInfoId = search.loanid
    loadReason("/api/loaning/comfirmOrReject", obj).then((res:any) => {
      Toast.clear()
			if (res.errcode === 0) {
        setFinancePlanStatus(obj.status)
				getData(search?.loanid)
        setReVisible(false)
        setVisible(false)
			} else {
        Toast.show(res?.errmsg || '操作失败');
      }
		}).catch((err)=>{
      Toast.show(err?.errmsg || '操作失败');
    })
  } 

      // 获取盗抢权益期限
      const getSsqyPeriods = (info:any) => {
        if (info.stage > 0) {
  
          let qyPeriods = 0
          if (info.stage <= 12) {
            qyPeriods = 1
          } else if (info.stage <= 24) {
            qyPeriods = 2
          } else if (info.stage <= 36) {
            qyPeriods = 3
          }
          if (info.netPrice < 30000 && qyPeriods == 3) {
            qyPeriods = 0
          }
          setPeriodsVal(qyPeriods)
        } else {
          setPeriodsVal(0)
        }
      }

  return (<div className="page bottomFit ApplyDetail">
    <CustomScroll>
      {financePlanStatus == 3&&data.rejectReason ? <div className="Apply-refuse">本人已拒绝，拒绝原因：{data.rejectReason}</div> : (financePlanStatus == 1 ? <div className="Apply-refuse">驳回原因：{data.rejectReason}</div> : null)}
      <div>
        <div className="info-box">
          <h2 className="dotted-line">车辆信息</h2>
          <ul>
            <li>
              <label>品牌：</label>
              <span>{data.brandname}</span>
            </li>
            <li>
              <label>车型：</label>
              <span>{data.vehiclename}</span>
            </li>
            <li>
              <label>车辆价格：</label>
              <span>{data.caramount || 0} 元</span>
            </li>
          </ul>
        </div>
        <div className="info-box">
          <h2 className="dotted-line">金融方案选择</h2>
          <ul>
            <li>
              <label>费率：</label>
              <span>{Number(((data.rate || 0) * 100).toFixed(2))}%</span>
            </li>
            <li>
              <label>履约保证金比例：</label>
              <span>{Number(((data.earnestmoneypercent || 0) * 100).toFixed(2))}%</span>
            </li>
            <li>
              <label>首付比例：</label>
              <span>{Number(((data.firstpaidpercent || 0) * 100).toFixed(2))}%</span>
            </li>
            <li>
              <label>租赁期数：</label>
              <span>{data.stage}期</span>
            </li>
            <li>
              <label>手续费率：</label>
              <span>{Number(((data.commissionrate || 0) * 100).toFixed(2))}%</span>
            </li>
            <li>
              <label>是否分期盗抢保障服务：</label>
              <span>{data?.containsecurityservice == 1?'是':'否'}</span>
            </li>
            <li>
              <label>盗抢保障费用：</label>
              <span>{data.securityserviceamount|| 0}元</span>
            </li>
            <li>
              <label>盗抢权益期限：</label>
              <span>{periodsVal || 0}年</span>
            </li>
            {/* <li>
              <label>是否超融购置税：</label>
              <span>{data.containtax ? "是" : "否"}</span>
            </li>
            <li>
              <label>购置税金额：</label>
              <span>{data.taxamount || 0} 元</span>
            </li> */}
          </ul>
        </div>
        <div className="info-box">
          <h2 className="dotted-line">方案展示（具体以还款计划表为准）</h2>
          <ul>
            <li>
              <label>融租总额：</label>
              <span>{data.finalamount || 0} 元</span>
            </li>
            <li>
              <label>首付款：</label>
              <span>{data.firstpaidamount || 0} 元</span>
            </li>
            <li>
              <label>月还款：</label>
              <span>{data.everypayamount || 0} 元</span>
            </li>
            <li>
              <label>骑行意外险费用：</label>
              <span>{data.rideaccidentserviceamount || 0} 元</span>
            </li>
            <li>
              <label>手续费：</label>
              <span>{data.commission || 0} 元</span>
            </li>
            {data?.mortgageserviceamount>0&&<li>
              <label>抵押代办费</label>
              <span>{data?.mortgageserviceamount || 0}元</span>
            </li>}
            <li>
              <label>履约保证金：<span>(结清可退还)</span></label>
              <span>{data.performanceBond || 0} 元</span>
            </li>
          </ul>
        </div>
      </div>{
        financePlanStatus == 2 ? <div className="ApplyDetail-footer">
          <div onClick={() => setReVisible(true)} className="refuseBtn">拒绝</div>
          <div onClick={() => setVisible(true)} className="SubmitBtn">确认</div>
        </div> : (financePlanStatus == 3 ? <div className="ApplyDetail-footer"><div className="button-them">已拒绝</div></div> : financePlanStatus!=1&&<div className="ApplyDetail-footer"><div className="button-them">已确认</div></div>)

      }
    </CustomScroll>
    {/* 确认modal */}
    <MiModal
      visible={visible}
      setVisible={setVisible}
      onSubmit={() => {
        subMitData({status: 4})
      }}
      content={
        <div className="miModal-content">是否确认金融方案？</div>
      }
    />
    {/* 拒绝modal */}
    <MiModal
      visible={reVisible}
      setVisible={setReVisible}
      miHeight={250}
      btnStyle={{padding: '0'}}
      onSubmit={() => {
        if (refuse) {
          subMitData({status: 3, reason: refuse})
        } else {
          Toast.show('请输入拒绝原因！')
        }
      }}
      content={
        <div className="miModal-content1">
          <div>请输入拒绝原因</div>
          <TextArea placeholder="请输入原因" maxLength={200} onChange={(e)=>{setRefuse(e)}}></TextArea>
        </div>
      }
    />
  </div>)
}

export default memo(ApplyDetail)